import { cn } from '@/_shared/lib/utils';

interface RudderstackBrandProps {
  variant?: 'full' | 'mark';
  className?: string;
  markClassName?: string;
  textClassName?: string;
  label?: string;
  badge?: string;
}

export function RudderstackBrand({
  variant = 'full',
  className,
  markClassName,
  textClassName,
  label = 'rudderstack',
  badge,
}: RudderstackBrandProps): React.ReactElement {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <svg aria-hidden="true" data-slot="brand-mark" viewBox="0 0 140 140" className={cn('size-8', markClassName)}>
        <path
          d="M0 6.667C0 2.985 2.985 0 6.667 0H136a4 4 0 0 1 4 4v129.333C140 137.015 137.015 140 133.333 140 59.695 140 0 80.305 0 6.667z"
          className="fill-primary"
        />
      </svg>
      {variant === 'full' && (
        <>
          <span className={cn('text-[1.55rem] font-semibold tracking-[-0.05em] text-primary', textClassName)}>
            {label}
          </span>
          {badge && (
            <span className="rounded-full border border-brand/20 bg-brand/8 px-2 py-0.5 text-[0.5625rem] font-semibold tracking-wider text-brand uppercase">
              {badge}
            </span>
          )}
        </>
      )}
    </div>
  );
}
